import * as React from 'react';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useIntersect } from '../../Utilities/UseIntersect';

export interface IFiltersProps {
    /** Visibility handler */
    setHidden: (isHidden) => void;
    isOverlay?: boolean;
}

const Filters: React.FunctionComponent<IFiltersProps> = (props) => {
    const [isHidden, setIsHidden] = React.useState<boolean | undefined>(undefined);
    const selector = props.isOverlay ? '#product-filters-overlay-wrapper' : '#product-filters-wrapper';
    const post = useIntersect({
        root: document.querySelector(selector),
        rootMargin: '16px',
        threshold: [1.0],
    });

    // Watch side intersections

    useEffect(() => {
        if (!props.isOverlay) {
            if (post.entry) {
                if (post.entry.intersectionRatio >= 1) {
                    props.setHidden(false);
                    setIsHidden(false);
                } else {
                    props.setHidden(true);
                    setIsHidden(true);
                }
            }
        } else {
            props.setHidden(false);
            setIsHidden(false);
        }

    }, [post.entry]);


    // Main output
    return (
        <div className={classNames('product-filters__form-item',isHidden && 'secondary')}>
            {props.children}
            <div style={{ height: 0, width: 0 }} ref={post.node}/>
        </div>
    );
};

Filters.displayName = 'Filters';

export default Filters;
